function hideZendesk() {
  window.zE && window.zE('messenger', 'hide');
}

function showZendesk() {
  window.zE && window.zE('messenger', 'show');
}

function openZendesk() {
  window.zE && window.zE('messenger', 'open');
}

// execute the function by default
(function () {
  const availableLanguagesPrefix = ['/fr', '/de', '/nl'];
  const availablePaths = [
    '/',
    '/pages/support',
    '/pages/all-terrain-e-bike-lemmo-one-overview',
    '/pages/features',
    '/pages/specifications',
    '/collections/accessories',
    '/pages/service',
    '/pages/about-us-new',
  ];
  let path = window.location.pathname;
  availableLanguagesPrefix.forEach((prefix) => {
    if (path.startsWith(prefix)) {
      path = path.replace(prefix, '');
      if (!path) {
        path = '/';
      }
    }
  });
  if (availablePaths.includes(path) == false) {
    hideZendesk();
  }
})();
